export default function getTrailDirectionsUrl(latitude?: number, longitude?: number) {
  if (!latitude || !longitude) return '';
  return `https://www.google.com/maps/dir/Current+Location/${latitude},${longitude}`;
}
